module.exports = __webpack_public_path__ + "static/media/onsemifcslogo.92d1a604.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/onsemifcslogo.svg
// module id = ./src/images/onsemifcslogo.svg
// module chunks = 2